import React__default from 'react';
import classnames from 'classnames';
import { ProductDetailActions } from '@grandvisionhq/fun-products';
import { useProductLink } from '../../../../../../utils/use-product-link.js';
import { useProductDetailContext } from '../../../../../Context/ProductDetailContext.js';

const QuantityContainerButton = ({ QuantityContainerComponent , item , isSelected , onClick  })=>{
    const { dispatch , productType , product  } = useProductDetailContext();
    const productLink = useProductLink(product.slug, item.value, productType);
    const handleButtonClick = ()=>{
        dispatch(ProductDetailActions.updateActiveVariant({
            sku: item.value
        }));
        window.history.replaceState(null, '', productLink);
        onClick();
    };
    return /*#__PURE__*/ React__default.createElement("button", {
        className: classnames('quantity-container__item', {
            _is_selected: isSelected
        }),
        onClick: handleButtonClick,
        "data-t": item.value
    }, /*#__PURE__*/ React__default.createElement(QuantityContainerComponent, {
        className: "quantity-container",
        label: item.label,
        subtext: item.subtext,
        aside: item.aside
    }));
};

export { QuantityContainerButton };
//# sourceMappingURL=QuantityContainerButton.js.map
